import { render } from "./DescriptionField.vue?vue&type=template&id=3a1ef9aa"
import script from "./DescriptionField.vue?vue&type=script&lang=js"
export * from "./DescriptionField.vue?vue&type=script&lang=js"

import "./DescriptionField.vue?vue&type=style&index=0&id=3a1ef9aa&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__